import React, { useEffect } from "react";
import "./step-progress.scss";
import { ONBOARDING_STEP } from "../../constants/app.constants";

export interface StepProgressProps {
    CurrentStep: string;
}

export const StepProgressComponent = ({ CurrentStep }: StepProgressProps): JSX.Element => {
    const [ProgressWidth, SetProgressWidth] = React.useState(2);
    const [PulseTrigger, SetPulseTrigger] = React.useState(false);

    useEffect(
        () => {
            switch(CurrentStep) {
                case ONBOARDING_STEP.WELCOME:
                    SetProgressWidth(5);
                    break;
                case ONBOARDING_STEP.WHO_IS_USING:
                    SetProgressWidth(5);
                    break;
                case ONBOARDING_STEP.TEAM_INTRO:
                    SetProgressWidth(33);
                    break;
                case ONBOARDING_STEP.USAGE:
                    SetProgressWidth(66);
                    break;
                case ONBOARDING_STEP.FINISH:
                    SetProgressWidth(100);
                    break;
            }
            SetPulseTrigger(true);
            setTimeout(() => SetPulseTrigger(false), 500);
        }, [CurrentStep]
    )
    return <div className={["step-progress-container",  ProgressWidth === 100 && "shrink"].join(" ")} style={{height: CurrentStep !== ONBOARDING_STEP.WELCOME ? "8px" : "0px"}}>
        <div className={["progress-bar", PulseTrigger && "pulse"].join(" ")} style={{width: `${ProgressWidth}%`}}></div>
    </div>
}